module.exports = __webpack_public_path__ + "img/service_img10.cc6d97df.png";